import * as React from 'react';
import { Component } from 'react';
import styles from '../styles/wizards/EditLinkedSpecificationWizard.scss';
import autobind from 'autobind-decorator';
import {
  __,
  mapStateToProps,
  setTableParams,
  validateForm,
} from '../core/utils';
import { readTask } from '../redux/actions/table/all_tasks';
import { readWorkingSetPlan } from '../redux/actions/table/working_set_plans';
import { readWorkingSetSpecification } from '../redux/actions/table/working_set_specifications';
import { readProduct } from '../redux/actions/table/products';
import { readTender } from '../redux/actions/table/tenders';
import { listFiles, readFile } from '../redux/actions/table/files';
import { uploadAttachmentVersion } from '../redux/actions/attachments';
import { setAttachmentParams } from '../redux/actions/general/attachments';
import { setNotification } from '../redux/actions/general/notification';
import * as _ from 'lodash';
import AddDocumentIcon from '../assets/images/add-document-60x60.svg';
import UploadAttachmentVersionForm from '../forms/attachment_wizard/UploadAttachmentVersionForm';

@mapStateToProps((state) => ({
  store: _.get(state.general, 'attachments'),
  task_store: _.get(state.table, 'all_tasks'),
}))
class UploadAttachmentVersionWizard extends Component {
  _refreshSource() {
    const { attachment_context } = this.props.store;
    const { task_store } = this.props;

    if (_.get(attachment_context, 'type') == 'files') {
      return Promise.all([
        listFiles(attachment_context.stage_id),
        readFile(
          attachment_context.stage_id,
          attachment_context.attachment_id,
        ),
      ]);
    }

    if (_.get(attachment_context, 'type') == 'meeting_items') {
      setTableParams('all_meetings', {
        forceUpdate: true,
      });

      if (_.get(attachment_context, 'task_id')) {
        readTask(attachment_context.task_id);
      }

      return Promise.resolve();
    }

    if (_.get(attachment_context, 'type') == 'working_set_plan') {
      return readWorkingSetPlan(attachment_context.plan_id);
    }

    if (_.get(attachment_context, 'type') == 'working_set_specification') {
      return readWorkingSetSpecification(
        attachment_context.specification_id,
      ).then(({ response }) => {
        setTableParams('working_set_specifications', {
          flyout: response.data,
        });
      });
    }

    if (_.get(attachment_context, 'type') == 'product') {
      return readProduct(attachment_context.product_id).then(({ response }) => {
        setTableParams('products', {
          flyout: response.data,
        });
      });
    }

    if (_.get(attachment_context, 'type') == 'tender') {
      return readTender(attachment_context.tender_id);
    }

    const task_id =
      _.get(attachment_context, 'task_id') || _.get(task_store, 'flyout.id');

    if (!task_id) {
      return Promise.resolve();
    }

    return readTask(task_id).then(({ response }) => {
      setTableParams('all_tasks', {
        flyout: response.data,
      });
    });
  }

  @autobind
  _handleSubmit(formData) {
    const { upload_attachment_version_wizard } = this.props.store;

    return validateForm(
      uploadAttachmentVersion(
        upload_attachment_version_wizard.attachment_id,
        formData,
      ).then(() =>
        this._refreshSource().then(() => {
          setNotification(
            __('attachments.notification.version-uploaded'),
          );

          setAttachmentParams({
            upload_attachment_version_wizard: undefined,
            attachment_context: undefined,
          });

          this.props.onClose();
        }),
      ),
    );
  }

  render() {
    const { upload_attachment_version_wizard } = this.props.store;

    return (
      <>
        <div className={styles.header}>
          <div className={styles.left}>
            <span>
              {__('attachments.wizard.upload-version.title')}
            </span>
            <span>
              {__('attachments.wizard.upload-version.subtitle')}
            </span>
          </div>
          <div className={styles.right}>
            <AddDocumentIcon />
          </div>
        </div>
        <div className={styles.body}>
          <UploadAttachmentVersionForm
            attachment={upload_attachment_version_wizard}
            onSubmit={this._handleSubmit}
            onClose={this.props.onClose}
            initialValues={{
              description: upload_attachment_version_wizard.description,
            }}
          />
        </div>
      </>
    );
  }
}

export default UploadAttachmentVersionWizard;
